import * as z from "zod";
//#region src/__generated__/files/supporting-document/zod/deleteFileMetasRequestDtoSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const deleteFileMetasRequestDtoSchema = z.object({
	initUserId: z.uuid(),
	ids: z.array(z.uuid()).min(1).refine((items) => new Set(items).size === items.length, { message: "Array entries must be unique" })
});
//#endregion
//#region src/__generated__/files/supporting-document/zod/deleteManySchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const deleteManyStatus200Schema = z.array(z.string());
const deleteManyResponseSchema = deleteManyStatus200Schema;
const deleteManyDataSchema = deleteFileMetasRequestDtoSchema;
//#endregion
//#region src/__generated__/files/supporting-document/zod/getCheckSumSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const getCheckSumPathFileIdSchema = z.uuid();
const getCheckSumStatus200Schema = z.string();
const getCheckSumResponseSchema = getCheckSumStatus200Schema;
//#endregion
//#region src/__generated__/files/supporting-document/zod/fileMetaDtoSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const fileMetaDtoSchema = z.object({
	id: z.uuid(),
	parentId: z.uuid().nullish(),
	sourceId: z.uuid(),
	sourceType: z.enum([
		"PROJECT_ID",
		"WORK_GROUP",
		"MODEL_REPOSITORY",
		"CONTRACTOR_MANAGEMENT",
		"COSMOS",
		"COSMOS_FOR_DELETE",
		"COSMOS_FOR_MIGRATE",
		"ONTOLOGY_FILE_UPLOAD",
		"CLASSIFIER_TABLE_ROW",
		"ONTOLOGY_CLASSIFIER_TABLE",
		"ONTOLOGY_CATALOG_DEFINITION",
		"ONTOLOGY_SFO_DEFINITION",
		"MODEL_PROPERTIES",
		"EKPTD_RESOURCE",
		"EKPTD_ROLE_APPLICATION",
		"EKPTD_REJECT_ROLE_APPLICATION",
		"EKPTD_REVOKE_ROLE_APPLICATION",
		"LIBRARY",
		"KNOWLEDGE_BASE",
		"EXTERNAL_REQUEST",
		"INTERNAL_REQUEST",
		"INTERNAL_REQUEST_SUPPORTING",
		"INTERNAL_REQUEST_TU_PART",
		"INTERNAL_REQUEST_FINAL_DECISION"
	]),
	versionParentId: z.uuid().nullish().describe("Id первой версии этого файла. Присутствует только если поле version > 1"),
	version: z.int(),
	baseName: z.string(),
	size: z.int(),
	ext: z.string().nullish(),
	type: z.enum([
		"DIRECTORY",
		"DOCUMENT",
		"CLASSIFIER_DOCUMENT",
		"MODEL",
		"MODEL_DATA",
		"MODEL_DATA_SIMPLIFIED",
		"IMAGE",
		"COMMENT_DOCUMENT",
		"COSMOS_DOCUMENT",
		"COSMOS_GEOSERVER_DOCUMENT",
		"BUILDING_MANAGEMENT_DOCUMENT",
		"TASK_TRACKER",
		"MODEL_REPOSITORY",
		"CONTRACTOR_MANAGEMENT",
		"ONTOLOGY_DOCUMENT",
		"COLLISION_DOCUMENT",
		"ROLE_APPLICATION",
		"RESOURCE_DOCUMENT",
		"LIBRARY_DOCUMENT",
		"KNOWLEDGE_BASE_DOCUMENT",
		"REQUEST_DOCUMENT",
		"SUPPORTING_DOCUMENT"
	]),
	createdAt: z.iso.datetime(),
	modifiedAt: z.iso.datetime(),
	isDeleted: z.boolean(),
	isBlocked: z.boolean(),
	previewId: z.uuid().nullish(),
	preview: z.string().nullish().describe("Файл preview закодированный в base64. Поле может быть null, если для данного элемента не поддерживаются preview либо, если для данного элемента preview еще не было получено/сконвертировано."),
	author: z.uuid(),
	hash: z.string().nullish()
});
//#endregion
//#region src/__generated__/files/supporting-document/zod/getFileMetaSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const getFileMetaPathFileIdSchema = z.uuid();
const getFileMetaStatus200Schema = fileMetaDtoSchema;
const getFileMetaResponseSchema = getFileMetaStatus200Schema;
//#endregion
//#region src/__generated__/files/supporting-document/zod/getFileMetasRequestDtoSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const getFileMetasRequestDtoSchema = z.object({ ids: z.array(z.uuid()).min(1).refine((items) => new Set(items).size === items.length, { message: "Array entries must be unique" }) });
//#endregion
//#region src/__generated__/files/supporting-document/zod/getFileMetasSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const getFileMetasStatus200Schema = z.array(fileMetaDtoSchema);
const getFileMetasResponseSchema = getFileMetasStatus200Schema;
const getFileMetasDataSchema = getFileMetasRequestDtoSchema;
//#endregion
//#region src/__generated__/files/supporting-document/zod/getLatestFileMetasRequestDtoSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const getLatestFileMetasRequestDtoSchema = z.object({ ids: z.array(z.uuid()).min(1).refine((items) => new Set(items).size === items.length, { message: "Array entries must be unique" }) });
//#endregion
//#region src/__generated__/files/supporting-document/zod/getLatestFileMetasSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const getLatestFileMetasStatus200Schema = z.array(fileMetaDtoSchema);
const getLatestFileMetasResponseSchema = getLatestFileMetasStatus200Schema;
const getLatestFileMetasDataSchema = getLatestFileMetasRequestDtoSchema;
//#endregion
//#region src/__generated__/files/supporting-document/zod/supportingDocumentListRequestSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const supportingDocumentListRequestSchema = z.object({ id: z.uuid() });
//#endregion
//#region src/__generated__/files/supporting-document/zod/supportingDocumentListResponseSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const supportingDocumentListResponseSchema = z.object({ fileMeta: fileMetaDtoSchema.nullish() });
//#endregion
//#region src/__generated__/files/supporting-document/zod/listSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const listStatus200Schema = z.array(supportingDocumentListResponseSchema);
const listResponseSchema = listStatus200Schema;
const listDataSchema = supportingDocumentListRequestSchema;
//#endregion
//#region src/__generated__/files/supporting-document/zod/supportingDocumentMoveRequestSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const supportingDocumentMoveRequestSchema = z.object({
	id: z.uuid(),
	parentId: z.uuid(),
	userId: z.uuid()
});
//#endregion
//#region src/__generated__/files/supporting-document/zod/supportingDocumentMoveResponseSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const supportingDocumentMoveResponseSchema = z.object({ moveCnt: z.int().nullish() });
//#endregion
//#region src/__generated__/files/supporting-document/zod/moveSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const moveStatus200Schema = z.array(supportingDocumentMoveResponseSchema);
const moveResponseSchema = moveStatus200Schema;
const moveDataSchema = supportingDocumentMoveRequestSchema;
//#endregion
//#region src/__generated__/files/supporting-document/zod/supportingDocumentRenameRequestSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const supportingDocumentRenameRequestSchema = z.object({
	id: z.uuid(),
	newName: z.string().min(1),
	userId: z.uuid()
});
//#endregion
//#region src/__generated__/files/supporting-document/zod/supportingDocumentRenameResponseSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const supportingDocumentRenameResponseSchema = z.object({ fileMeta: fileMetaDtoSchema.nullish() });
//#endregion
//#region src/__generated__/files/supporting-document/zod/renameSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const renameStatus200Schema = supportingDocumentRenameResponseSchema;
const renameResponseSchema = renameStatus200Schema;
const renameDataSchema = supportingDocumentRenameRequestSchema;
//#endregion
//#region src/__generated__/files/supporting-document/zod/resolveLatestFileMetasRequestDtoSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const resolveLatestFileMetasRequestDtoSchema = z.object({ ids: z.array(z.uuid()).min(1).refine((items) => new Set(items).size === items.length, { message: "Array entries must be unique" }) });
//#endregion
//#region src/__generated__/files/supporting-document/zod/resolveLatestFileMetasSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const resolveLatestFileMetasStatus200Schema = z.array(fileMetaDtoSchema);
const resolveLatestFileMetasResponseSchema = resolveLatestFileMetasStatus200Schema;
const resolveLatestFileMetasDataSchema = resolveLatestFileMetasRequestDtoSchema;
//#endregion
export { getFileMetaStatus200Schema as A, getLatestFileMetasRequestDtoSchema as C, getFileMetasRequestDtoSchema as D, getFileMetasStatus200Schema as E, deleteManyDataSchema as F, deleteManyResponseSchema as I, deleteManyStatus200Schema as L, getCheckSumPathFileIdSchema as M, getCheckSumResponseSchema as N, getFileMetaPathFileIdSchema as O, getCheckSumStatus200Schema as P, deleteFileMetasRequestDtoSchema as R, getLatestFileMetasStatus200Schema as S, getFileMetasResponseSchema as T, listStatus200Schema as _, renameDataSchema as a, getLatestFileMetasDataSchema as b, supportingDocumentRenameResponseSchema as c, moveResponseSchema as d, moveStatus200Schema as f, listResponseSchema as g, listDataSchema as h, resolveLatestFileMetasRequestDtoSchema as i, fileMetaDtoSchema as j, getFileMetaResponseSchema as k, supportingDocumentRenameRequestSchema as l, supportingDocumentMoveRequestSchema as m, resolveLatestFileMetasResponseSchema as n, renameResponseSchema as o, supportingDocumentMoveResponseSchema as p, resolveLatestFileMetasStatus200Schema as r, renameStatus200Schema as s, resolveLatestFileMetasDataSchema as t, moveDataSchema as u, supportingDocumentListResponseSchema as v, getFileMetasDataSchema as w, getLatestFileMetasResponseSchema as x, supportingDocumentListRequestSchema as y };

//# sourceMappingURL=resolveLatestFileMetasSchema.js.map